import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.concat.js";
var prefix = '[smy-vux] - ';
var LOCAL_KEY = ['globalStore/Authorization'];
export default {
  namespace: '',
  setNamespace: function setNamespace(namespace) {
    this.namespace = namespace;
  },
  // set (key, value) {
  //   window.sessionStorage.setItem(prefix + key, JSON.stringify(value))
  // },
  // get (key) {
  //   // key = this.namespace ? (this.namespace + '/' + key) : key
  //   let value = window.sessionStorage.getItem(prefix + this.namespace + '/' + key)
  //   return value ? JSON.parse(value) : ''
  // }
  set: function set(key, value) {
    if (LOCAL_KEY.indexOf(key) !== -1) {
      window.localStorage.setItem(prefix + key, JSON.stringify(value));
    } else {
      window.sessionStorage.setItem(prefix + key, JSON.stringify(value));
    }
  },
  get: function get(key) {
    // key = this.namespace ? (this.namespace + '/' + key) : key
    var value = '';
    if (LOCAL_KEY.indexOf("".concat(this.namespace, "/").concat(key)) !== -1) {
      value = window.localStorage.getItem(prefix + this.namespace + '/' + key);
    } else {
      value = window.sessionStorage.getItem(prefix + this.namespace + '/' + key);
    }
    return value ? JSON.parse(value) : '';
  }
};